import { Route, Routes } from 'react-router';

import PolicyPackagesDetail from './PolicyPackagesDetail';

export default function PolicyPackagesRoutes() {
  return (
    <Routes>
      <Route path="/:id" element={<PolicyPackagesDetail />} />
    </Routes>
  );
}
